var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function (resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator['throw'](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = this && this.__generator || function (thisArg, body) {
    var _ = {
            label: 0,
            sent: function () {
                if (t[0] & 1)
                    throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
    return g = {
        next: verb(0),
        'throw': verb(1),
        'return': verb(2)
    }, typeof Symbol === 'function' && (g[Symbol.iterator] = function () {
        return this;
    }), g;
    function verb(n) {
        return function (v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f)
            throw new TypeError('Generator is already executing.');
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y['return'] : op[0] ? y['throw'] || ((t = y['return']) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [
                        op[0] & 2,
                        t.value
                    ];
                switch (op[0]) {
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [0];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2])
                        _.ops.pop();
                    _.trys.pop();
                    continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
import React, { useState } from 'react';
import { inject } from 'mobx-react';
import { observer } from 'mobx-react-lite';
import {
    Button,
    Dialog
} from 'oned';
import classNames from 'classnames';
import { AvailabilityBusiness } from '@business/newCreateRequest/stepsItems/availability';
import { AmplitudeEventName } from '@common/enums/base';
import { RES_PATH } from '@common/config';
import moment from 'moment';
import {
    getCurrentEnv,
    sendAmplitude_Default
} from '@common/utils';
import Cookies from 'js-cookie';
var NewAutoSchedule = inject(AvailabilityBusiness)(observer(function (props) {
    var scheduleTimeBlocks = props.scheduleTimeBlocks, isShowBundle = props.isShowBundle, setAvailabilityParams = props.setAvailabilityParams, isShowAllOptions = props.isShowAllOptions, setSelectedSchedule = props.setSelectedSchedule, selectedSchedule = props.selectedSchedule, isAutoScheduleNextDisabled = props.isAutoScheduleNextDisabled, loading = props.loading, currentUser = props.currentUser, next = props.next, getAutoScheduleData = props.getAutoScheduleData, bundleWOs = props.bundleWOs, autoScheduleRecommendLength = props.autoScheduleRecommendLength, setTargetDisclaimer = props.setTargetDisclaimer, canSchedule = props.canSchedule;
    var _a = useState(false), isShowNoScheduleTimeDialog = _a[0], setIsShowNoScheduleTimeDialog = _a[1];
    var toggleText = function () {
        setAvailabilityParams('isShowAllOptions', !isShowAllOptions);
    };
    var handleNext = function () {
        return __awaiter(void 0, void 0, void 0, function () {
            var isPass;
            return __generator(this, function (_a) {
                switch (_a.label) {
                case 0:
                    return [
                        4,
                        getAutoScheduleData()
                    ];
                case 1:
                    _a.sent();
                    return [
                        4,
                        canSchedule()
                    ];
                case 2:
                    isPass = _a.sent();
                    if (isPass === false) {
                        setIsShowNoScheduleTimeDialog(true);
                        return [
                            2,
                            false
                        ];
                    }
                    sendAmplitude_Default(AmplitudeEventName.NewRSP_Step4to5, {
                        userId: currentUser.userId,
                        residentId: currentUser.residentId,
                        clientId: Cookies.get('clientId'),
                        env: getCurrentEnv()
                    });
                    next();
                    setTargetDisclaimer(false);
                    return [2];
                }
            });
        });
    };
    var toggleSingle = function () {
        setAvailabilityParams('isShowBundle', false);
        setAvailabilityParams('selectedSchedule', {});
        setAvailabilityParams('isShowAllOptions', false);
    };
    var defaultIconUrl = RES_PATH + 'sources/svg/sc_default.svg';
    var description = isShowBundle ? 'We see you have another upcoming appointment that can be completed at the same time.' : 'Good news, we can schedule your service with one of our technicians. Select the time slot you would like to schedule the service.';
    return React.createElement(React.Fragment, null, React.createElement('div', { className: 'dsm-card' }, React.createElement('div', { className: 'dsm-card-body' }, Object.keys(scheduleTimeBlocks).length > 0 && (scheduleTimeBlocks.allRecommendList.length > 0 || scheduleTimeBlocks.pushOutRecommendList.length > 0) && !(!isShowBundle && scheduleTimeBlocks.allRecommendList.length === 0) && React.createElement('div', { className: 'py-2 px-20 autoSchedule' }, React.createElement('h2', { className: 'page-title' }, React.createElement('b', null, 'Schedule your service')), React.createElement('div', { className: 'pt-2 f16' }, description), isShowBundle && bundleWOs && bundleWOs.length > 0 && React.createElement(React.Fragment, null, React.createElement('div', { className: 'row' }, bundleWOs.map(function (x) {
        return React.createElement('div', { className: 'col-md-6 col-sm-12' }, React.createElement('div', { className: 'rsp-card my-2 cp bundle-wrapper' }, React.createElement('div', { className: 'rsp-card-body d-flex' }, React.createElement('img', {
            className: 'bundle-icon',
            src: defaultIconUrl
        }), React.createElement('div', { className: 'pl-3' }, React.createElement('div', {
            className: 'bundle-title',
            title: x.serviceCombination
        }, React.createElement('b', null, x.serviceCombination)), React.createElement('div', { className: 'bundle-detail' }, 'Created ', moment(x.createDate).format('MMMM DD, YYYY'))))));
    }))), React.createElement('div', { className: 'pt-4' }, isShowBundle && scheduleTimeBlocks.pushOutRecommendList.map(function (x) {
        return React.createElement(React.Fragment, null, React.createElement('h2', { className: 'page-title' }, React.createElement('b', null, 'Does this time still work well for both issues to be completed?')), React.createElement('div', { className: 'm-t-20 bottom autoSchedule-view row' }, React.createElement('div', { className: 'autoSchedule-view-item col-md-4 col-sm-12' }, React.createElement('div', {
            className: 'btTitle',
            dangerouslySetInnerHTML: { __html: x.formatDate }
        }), React.createElement('div', { className: 'm-t-20' }, x.list.map(function (o) {
            return React.createElement('div', {
                className: classNames('btItem cp', selectedSchedule && selectedSchedule.scheduleStartTime === o.scheduleStartTime && 'active'),
                onClick: function () {
                    setSelectedSchedule(o);
                }
            }, o.timeQuantumValue);
        })))));
    }), !isShowBundle && React.createElement('h2', { className: 'page-title' }, React.createElement('b', null, 'Availability options')), !isShowBundle && React.createElement('div', { className: 'm-t-20 bottom autoSchedule-view row' }, !isShowAllOptions && scheduleTimeBlocks.topRecommendList.map(function (x) {
        return React.createElement(React.Fragment, null, React.createElement('div', { className: 'autoSchedule-view-item col-md-4 col-sm-12' }, React.createElement('div', {
            className: 'btTitle',
            dangerouslySetInnerHTML: { __html: x.formatDate }
        }), React.createElement('div', { className: 'm-t-20' }, x.list.map(function (o) {
            return React.createElement('div', {
                className: classNames('btItem cp', selectedSchedule && selectedSchedule.scheduleStartTime === o.scheduleStartTime && 'active'),
                onClick: function () {
                    setSelectedSchedule(o);
                }
            }, o.timeQuantumValue);
        }))));
    }), isShowAllOptions && scheduleTimeBlocks.allRecommendList.map(function (x) {
        return React.createElement(React.Fragment, null, React.createElement('div', { className: 'autoSchedule-view-item col-md-4 col-sm-12' }, React.createElement('div', {
            className: 'btTitle',
            dangerouslySetInnerHTML: { __html: x.formatDate }
        }), React.createElement('div', { className: 'm-t-20' }, x.list.map(function (o) {
            return React.createElement('div', {
                className: classNames('btItem cp', selectedSchedule && selectedSchedule.scheduleStartTime === o.scheduleStartTime && 'active'),
                onClick: function () {
                    setSelectedSchedule(o);
                }
            }, o.timeQuantumValue);
        }))));
    })), !isShowBundle && autoScheduleRecommendLength > 3 && React.createElement('a', {
        className: 'center f16 cp',
        onClick: toggleText
    }, !isShowAllOptions ? 'See all availability options' : 'Hide availability options'))), Object.keys(scheduleTimeBlocks).length && (scheduleTimeBlocks.allRecommendList.length === 0 && scheduleTimeBlocks.pushOutRecommendList.length === 0 || !isShowBundle && scheduleTimeBlocks.allRecommendList.length === 0) && React.createElement('div', { className: 'w-100 d-flex justify-content-center py-5' }, 'No technician available at that time, please contact your local office.'))), !isShowBundle && React.createElement(Button, {
        type: 'primary',
        className: 'w-100 my-3 dsm-btn-primary dsm-btn f14',
        disabled: isAutoScheduleNextDisabled || loading,
        onClick: function () {
            setAvailabilityParams('isSelectPushOutTechnician', false);
            handleNext();
        }
    }, 'Next'), isShowBundle && React.createElement('div', { className: 'row no-gutters w-100' }, React.createElement('div', { className: 'col-md-6 col-sm-12 center mt-2 d-flex align-items-center justify-content-center' }, React.createElement('a', {
        className: 'f14 p-2',
        onClick: toggleSingle
    }, 'No, I need a different time')), React.createElement('div', { className: 'col-md-6 col-sm-12 mt-2' }, React.createElement(Button, {
        type: 'primary',
        className: 'w-100 my-3 dsm-btn-primary dsm-btn f14',
        disabled: isAutoScheduleNextDisabled || loading,
        onClick: function () {
            setAvailabilityParams('isSelectPushOutTechnician', true);
            handleNext();
        }
    }, 'Yes, same schedule time'))), React.createElement(Dialog, {
        visible: isShowNoScheduleTimeDialog,
        title: 'Schedule failed',
        onClose: function () {
            setIsShowNoScheduleTimeDialog(false);
        },
        hasFooter: false
    }, React.createElement('div', { className: 'pb-4' }, 'This time window is no longer available. Please select a different time window to continue.')));
}));
export default NewAutoSchedule;